import React from 'react'

function PaymentFailed() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-pink-100 flex items-center justify-center px-4">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full text-center">
        <div className="text-red-500 text-6xl mb-4">✗</div>
        <h2 className="text-3xl font-bold text-gray-800 mb-2">Payment Failed</h2>
        <p className="text-gray-600 mb-6">Unfortunately, your payment could not be processed.</p>
      </div>
    </div>
  )
}

export default PaymentFailed